import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import Loading from "../../Components/Loading";
import { Card, Button, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import SearchInput from "../../Components/SearchInput";
import Dialog from "../../Components/Dialog";
import KakaoAddress from "../../Components/Kakao/DaumPostCode";
import Swal from "../../Components/SweetAlert2";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPersonChalkboard, faFileLines, faHelmetSafety, faChevronLeft, faChevronRight, faLocationDot } from "@fortawesome/free-solid-svg-icons";
/** Images Import */
import CompleteStamp from "../../Assets/Images/complete_stamp.png";

function Composed() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const language = useSelector((state) => state.localStorage.language);
  const authorization = useSelector((state) => state.localStorage.authorization);
  const [userInfo, setUserInfo] = useState({});
  const [myDataList, setMyDataList] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [dialogStep, setDialogStep] = useState(0);
  const [dialogLoading, setDialogLoading] = useState(false);
  // const formTitles = ["작업 예정일 및 현장 선택", "공종 선택(중복 선택 가능)", "단위작업 선택(중복 선택 가능)", "기초 건강 진단"];
  const formTitles = ["작업 예정일 및 현장 선택", "기초 건강 진단"];
  const [formData, setFormData] = useState({
    jobDate: "", // 작업 예정일
    siteId: "",
    siteName: "",
    eduId: "",
    constructionTypeList: [],
    constructionTypes: [],
    unitList: [],
    units: [],
    address: "", // 주소
    emergencyPhone: "", // 비상연락처
    highBloodPressure: "", // 최고 혈압
    lowBloodPressure: "", // 최저 혈압
    workExperience: "-1", // 경력
    smoking: "0", // 흡연 여부
    drinking: "0", // 음주 여부
    pledgeConfirmed: false, // 안전 서약서 동의 여부
  });
  const [checkedSiteList, setCheckedSiteList] = useState([]);
  const [dialogSearchText, setDialogSearchText] = useState("");
  const [dialog1, setDialog1] = useState(false); // 주소검색 창
  const [wording, setWording] = useState({
    waiting: "승인 대기 중입니다...",
    goToEducation: "교육 들으러 가기",
    rejectReason: "반려 사유: ",
    goToConstruction: "위험성 평가 하러 가기",
    completeConstruction: "위험성 평가 완료",
    makeHealthDocument: "보건 서류 작성",
    complete: "완료",
    next: "다음",
    futureDay: "작업 예정일을 입력하세요. (예:",
    placeholder1: "검색어를 입력해주세요.",
    placeholder2: "비상연락처를 입력하세요.",
    placeholder3: "클릭하면 주소검색 창이 나옵니다.",
    placeholder4: "최고 혈압을 입력하세요.",
    placeholder5: "최저 혈압을 입력하세요.",
  });

  useEffect(() => {
    console.log("location.state: ", location.state);
    Init();
  }, []);

  useEffect(() => {
    if (!authorization.auth) {
      navigate("/");
    }
  }, [authorization.auth]);

  // 자동으로 다음 단계로 진행하는 useEffect
  useEffect(() => {
    if (dialogStep === 0 && formData.siteId && formData.siteName) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (formData.jobDate && dateRegex.test(formData.jobDate)) {
        // 연도 범위 검사 (1900년~2500년)
        const year = parseInt(formData.jobDate.split("-")[0]);
        if (year >= 1900 && year <= 2500) {
          setDialogStep(1);
          setDialogSearchText("");
          Search1("constructionType");
        }
      }
    }
  }, [formData]);

  const Init = async () => {
    try {
      const userData = await IndexedDb.GetUserInfo();
      setUserInfo(userData);
      await Search();
      const _waiting = await TranslationService.translateText(wording.waiting, language.lang);
      const _goToEducation = await TranslationService.translateText(wording.goToEducation, language.lang);
      const _rejectReason = await TranslationService.translateText(wording.rejectReason, language.lang);
      const _goToConstruction = await TranslationService.translateText(wording.goToConstruction, language.lang);
      const _completeConstruction = await TranslationService.translateText(wording.completeConstruction, language.lang);
      const _makeHealthDocument = await TranslationService.translateText(wording.makeHealthDocument, language.lang);
      const _complete = await TranslationService.translateText(wording.complete, language.lang);
      const _next = await TranslationService.translateText(wording.next, language.lang);
      const _futureDay = await TranslationService.translateText(wording.futureDay, language.lang);
      const _placeholder1 = await TranslationService.translateText(wording.placeholder1, language.lang);
      const _placeholder2 = await TranslationService.translateText(wording.placeholder2, language.lang);
      const _placeholder3 = await TranslationService.translateText(wording.placeholder3, language.lang);
      const _placeholder4 = await TranslationService.translateText(wording.placeholder4, language.lang);
      const _placeholder5 = await TranslationService.translateText(wording.placeholder5, language.lang);
      setWording({
        ...wording,
        waiting: _waiting,
        goToEducation: _goToEducation,
        rejectReason: _rejectReason,
        goToConstruction: _goToConstruction,
        completeConstruction: _completeConstruction,
        makeHealthDocument: _makeHealthDocument,
        complete: _complete,
        next: _next,
        futureDay: _futureDay,
        placeholder1: _placeholder1,
        placeholder2: _placeholder2,
        placeholder3: _placeholder3,
        placeholder4: _placeholder4,
        placeholder5: _placeholder5,
      });
    } catch (e) {
      console.log("Init Error: ", e);
    }
  };

  // 신청한 보건교육 카드 조회
  const Search = async () => {
    try {
      setLoading(true);
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.GetHealthEdu, { companyCode: location.state.company.companyCode }).then((result) => {
        let data = result.data;
        console.log("Search: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          // 같은 siteId를 가진 데이터 중 우선순위 조건에 따라 필터링
          const filteredData = data.reduce((acc, current) => {
            const existingItem = acc.find((item) => item.siteId === current.siteId);

            if (!existingItem) {
              // 해당 siteId의 첫 번째 데이터
              acc.push(current);
            } else {
              // 우선순위 조건에 따라 데이터 교체 여부 결정
              let shouldReplace = false;

              // 1. lastViewedAt이 가장 최신인 데이터가 있다면 우선 선택
              if (current.lastViewedAt && existingItem.lastViewedAt) {
                const currentDate = new Date(current.lastViewedAt);
                const existingDate = new Date(existingItem.lastViewedAt);
                if (currentDate > existingDate) {
                  shouldReplace = true;
                }
              } else if (current.lastViewedAt && !existingItem.lastViewedAt) {
                // 현재 데이터에만 lastViewedAt이 있는 경우 교체
                shouldReplace = true;
              } else if (!current.lastViewedAt && existingItem.lastViewedAt) {
                // 기존 데이터에만 lastViewedAt이 있는 경우 교체하지 않음
                shouldReplace = false;
              } else {
                // 둘 다 lastViewedAt이 없는 경우 approvalState 우선순위로 결정
                const priorityOrder = { N: 4, Y: 3, W: 2 };
                const currentPriority = priorityOrder[current.approvalState] || 1;
                const existingPriority = priorityOrder[existingItem.approvalState] || 1;

                if (currentPriority > existingPriority) {
                  shouldReplace = true;
                }
              }

              if (shouldReplace) {
                const index = acc.findIndex((item) => item.siteId === current.siteId);
                acc[index] = current;
              }
            }
            return acc;
          }, []);

          const sortedData = filteredData.sort((a, b) => {
            // 정렬 우선순위: N > Y > W > 기타
            const priorityOrder = { N: 4, Y: 3, W: 2 };
            const aPriority = priorityOrder[a.approvalState] || 1;
            const bPriority = priorityOrder[b.approvalState] || 1;

            if (aPriority !== bPriority) {
              return bPriority - aPriority; // 높은 우선순위가 먼저 오도록
            }
            return 0;
          });
          setMyDataList(sortedData);
        }
      });
    } catch (e) {
      console.log("Search Error: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 직책 조회
  const Search1 = async (_type) => {
    try {
      setDialogLoading(true);

      let _param = "";
      switch (_type) {
        case "constructionType":
          _param = "CONSTRUCTION_TYPE";
          break;
        case "unit":
          _param = "CONSTRUCTION_TYPE_UNIT";
          break;
      }

      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.getCode, {
        code: _param,
        // key1: formData.siteId,
        key1: "SITE-1",
        key3: "",
      });
      console.log("Search1 Response: ", response);
      if (response.status === 200) {
        if (_type === "constructionType") {
          setFormData({ ...formData, constructionTypeList: response.data });
        } else if (_type === "unit") {
          setFormData({ ...formData, unitList: response.data });
        }
      } else {
        throw new Error(response.data);
      }
    } catch (e) {
      console.log("Search1 Error: ", e);
    } finally {
      setDialogLoading(false);
    }
  };

  // 재신청을 위한 이전 보건 기록 조회
  const Search2 = async (_param = "") => {
    try {
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.HealthSafety, {
        companyCode: location.state.company?.companyCode,
        siteId: _param,
        empId: userInfo.userId,
      });
      console.log("Search2 response: ", response);

      if (!response) {
        setFormData({
          jobDate: "", // 작업 예정일
          siteId: "",
          siteName: "",
          eduId: "",
          constructionTypeList: [],
          constructionTypes: [],
          unitList: [],
          units: [],
          address: "", // 주소
          emergencyPhone: "", // 비상연락처
          highBloodPressure: "", // 최고 혈압
          lowBloodPressure: "", // 최저 혈압
          workExperience: "-1", // 경력
          smoking: "0", // 흡연 여부
          drinking: "0", // 음주 여부
          healthCheck: [],
          ppeIssueStatus: [],
          pledgeConfirmed: false, // 안전 서약서 동의 여부
        });
      } else if (response.status === 404) {
        setFormData({
          jobDate: "", // 작업 예정일
          siteId: "",
          siteName: "",
          eduId: "",
          constructionTypeList: [],
          constructionTypes: [],
          unitList: [],
          units: [],
          address: "", // 주소
          emergencyPhone: "", // 비상연락처
          highBloodPressure: "", // 최고 혈압
          lowBloodPressure: "", // 최저 혈압
          workExperience: "-1", // 경력
          smoking: "0", // 흡연 여부
          drinking: "0", // 음주 여부
          healthCheck: [],
          ppeIssueStatus: [],
          pledgeConfirmed: false, // 안전 서약서 동의 여부
        });
      } else if (response.status === 200) {
        const responseData = response.data;
        console.log("재신청 responseData: ", responseData);
        setFormData((prev) => ({
          ...prev,
          ...responseData,
        }));
        setDialogStep(1);
        setDialog(true);
      } else {
        throw new Error(response.data);
      }
    } catch (e) {
      console.log("Search2 error: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 보건 교육 카드 만들 수 있는지 체크하는 로직
  const Search3 = async () => {
    try {
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.RiskFactor.Availability, {
        companyCode: location.state.company.companyCode,
      });
      console.log("Search3 response: ", response.data);
      if (response.status === 200) {
        let _count = 0;
        if (Array.isArray(response.data)) {
          response.data.forEach((item) => {
            if (item.canApply === "N") {
              _count++;
            }
          });
        }
        setCheckedSiteList(response.data);
        if (_count === response.data.length) {
          Swal.warning("보건 교육 카드 만들 수 있는 현장이 없습니다.");
        } else {
          setDialog(true);
        }
      } else {
        throw new Error(JSON.stringify(response));
      }
    } catch (e) {
      console.log("Search3 error: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 교육 승인 요청 로직
  const Sumit = async (_param = "") => {
    try {
      if (!formData.address) {
        Swal.warning("주소를 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (!formData.highBloodPressure) {
        Swal.warning("최고 혈압을 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (!formData.lowBloodPressure) {
        Swal.warning("최저 혈압을 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (formData.workExperience === "-1") {
        Swal.warning("경력을 선택해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (formData.smoking === "0") {
        Swal.warning("흡연 여부를 선택해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (formData.drinking === "0") {
        Swal.warning("음주 여부를 선택해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      let params = {
        siteId: formData.siteId,
        companyCode: location.state.company.companyCode,
        empId: userInfo.userId,
        eduId: 0,
        jobDate: formData.jobDate,
        address: formData.address,
        phone: userInfo.tel ?? "",
        emergencyPhone: formData.emergencyPhone,
        highBloodPressure: formData.highBloodPressure,
        lowBloodPressure: formData.lowBloodPressure,
        workExperience: formData.workExperience,
        smoking: formData.smoking,
        drinking: formData.drinking,
        healthCheck: formData.healthCheck ?? {},
        ppeIssueStatus: formData.ppeIssueStatus ?? {},
        constructionTypes: formData.constructionTypes,
        units: formData.units,
        pledgeConfirmed: formData.pledgeConfirmed,
      };
      console.log("Sumit params: ", JSON.stringify(params));
      await Commons.Axios("post", Global.base.useUrl + Global.urls.Content.HealthSafety, {}, JSON.stringify(params)).then((result) => {
        let data = result.data;
        console.log("Sumit: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Swal.success("교육 신청이 완료되었습니다.");
          setFormData({
            jobDate: "", // 작업 예정일
            siteId: "",
            siteName: "",
            eduId: "",
            constructionTypeList: [],
            constructionTypes: [],
            unitList: [],
            units: [],
            address: "", // 주소
            emergencyPhone: "", // 비상연락처
            highBloodPressure: "", // 최고 혈압
            lowBloodPressure: "", // 최저 혈압
            workExperience: "-1", // 경력
            smoking: "0", // 흡연 여부
            drinking: "0", // 음주 여부
            pledgeConfirmed: false, // 안전 서약서 동의 여부
          });
          Init();
        }
      });
    } catch (e) {
      console.log("Sumit Error: ", e);
    } finally {
      setLoading(false);
    }
  };

  const NextStep = () => {
    if (dialogStep === formTitles.length - 1) {
      console.log("formData: ", formData);
      setDialog(false);
      
      setDialogStep(0);
      Sumit(formData.siteId);
      return;
    }

    switch (dialogStep) {
      case 0: // 작업 예정일 및 현장 선택
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (formData.jobDate && dateRegex.test(formData.jobDate) && formData.siteId) {
          // 연도 범위 검사 (1900년~2500년)
          const year = parseInt(formData.jobDate.split("-")[0]);
          if (year < 1900 || year > 2500) {
            Swal.warning("작업 예정일은 1900년~2500년 사이의 날짜만 입력 가능합니다.");
            return;
          }
          setDialogStep(1);
          setDialogSearchText("");
          Search1("constructionType");
          // Search1("jobPositions");
        } else {
          if (!formData.jobDate) {
            Swal.warning("작업 예정일을 입력해주세요.");
          } else if (!dateRegex.test(formData.jobDate)) {
            Swal.warning("작업 예정일 형식이 올바르지 않습니다.");
          } else if (!formData.siteId) {
            Swal.warning("현장을 선택해주세요.");
          }
        }
        break;
      default:
        setDialogStep(dialogStep + 1);
        break;
    }
  };

  const HandleReceivePost = (data) => {
    console.log("HandleReceivePost data: ", data);
    setFormData((prev) => ({
      ...prev,
      address: data.address,
    }));
    setDialog1(false);
  };

  return (
    <div className='wrapper'>
      {loading && <Loading />}
      <div className='flex-column-center'>
        {Commons.IsMobile() ? (
          <div className='flex-column w-100 my-3'>
            <div className={`${Commons.IsMobile() ? "flex-evenly-center w-100" : "flex-end-center gap-2"}`}>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #fd7e14", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>승인 대기</AutoTranslate>
                </span>
              </div>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #03bbfe", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>미완료</AutoTranslate>
                </span>
              </div>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #198754", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>완료</AutoTranslate>
                </span>
              </div>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #ff0000", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>반려</AutoTranslate>
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className='flex-between-center w-100 my-3'>
            <div className={`${Commons.IsMobile() ? "flex-evenly-center w-100" : "flex-end-center gap-4"}`}>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #fd7e14", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>승인 대기</AutoTranslate>
                </span>
              </div>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #03bbfe", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>미완료</AutoTranslate>
                </span>
              </div>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #198754", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>완료</AutoTranslate>
                </span>
              </div>
              <div className='flex-start-center gap-2'>
                <div style={{ width: "16px", height: "16px", border: "2px solid #ff0000", borderRadius: "50%" }} />
                <span>
                  <AutoTranslate targetLanguage={language.lang}>반려</AutoTranslate>
                </span>
              </div>
            </div>
          </div>
        )}
        <div className='w-100 my-3'>
          {myDataList.map((item, index) => {
            return (
              <Card
                key={index}
                className={`w-100 mb-4 modern-card ${
                  item.approvalState === "Y" && parseInt(item.achievement) === 100 && item.riskFactorCompletion === "Y" && item.pledgeConfirmed ? "modern-card-success" : ""
                }`}
                style={{
                  position: "relative",
                  borderRadius: "16px",
                  border: "none",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                  background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                  borderColor:
                    item.approvalState === "Y" && parseInt(item.achievement) === 100 && item.riskFactorCompletion === "Y" && item.pledgeConfirmed
                      ? "#198754"
                      : item.approvalState === "N"
                      ? "#dc3545"
                      : "",
                }}
              >
                <Card.Header
                  className={`modern-card-header ${
                    item.approvalState === "Y" && parseInt(item.achievement) === 100 && item.riskFactorCompletion === "Y" && item.pledgeConfirmed ? "modern-card-header-success" : ""
                  }`}
                  style={{
                    padding: "1.5rem 1.5rem 1rem 1.5rem",
                    borderBottom: "1px solid rgba(0,0,0,0.05)",
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                  }}
                >
                  <div className='flex-between-center w-100'>
                    <div>
                      <Card.Title
                        style={{
                          textDecoration: item.approvalState === "N" ? "line-through" : "none",
                          fontSize: "1.3rem",
                          fontWeight: "700",
                          color: "#2c3e50",
                          marginBottom: "0.4rem",
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>{item.siteName}</AutoTranslate>
                      </Card.Title>
                      <Card.Subtitle
                        style={{
                          fontSize: "0.9rem",
                          color: "#6c757d",
                          fontWeight: "500",
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>{`작업 예정일: ${item.jobDate}`}</AutoTranslate>
                      </Card.Subtitle>
                    </div>
                    {item.approvalState === "N" && (
                      <Button
                        className='flex-center-center gap-2 modern-btn-warning'
                        variant='warning'
                        style={{
                          borderRadius: "10px",
                          padding: "0.6rem 1.2rem",
                          fontWeight: "600",
                          border: "none",
                          boxShadow: "0 4px 12px rgba(255, 193, 7, 0.3)",
                          transition: "all 0.3s ease",
                          fontSize: "0.85rem",
                        }}
                        onClick={() => {
                          Swal.custom({
                            title: `${item.siteName} 재신청`,
                            text: "해당 카드 내용으로 재신청 하시겠습니까?",
                            icon: "question",
                            showConfirmButton: true,
                            confirmButtonText: "재신청",
                            showCancelButton: true,
                            cancelButtonText: "취소",
                          }).then(async (result) => {
                            console.log("재신청 클릭", result);
                            if (result.isConfirmed) {
                              Swal.close();
                              await Search2(item.siteId);
                            } else {
                              Swal.close();
                            }
                          });
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>재신청 하기</AutoTranslate>
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: "1.5rem" }}>
                  <div
                    className='flex-start-center gap-2 mb-3'
                    style={{
                      padding: "0.8rem",
                      background: "rgba(52, 152, 219, 0.1)",
                      borderRadius: "10px",
                      border: "1px solid rgba(52, 152, 219, 0.2)",
                    }}
                  >
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#3498db", fontSize: "1rem" }} />
                    <span style={{ color: "#2c3e50", fontWeight: "500", fontSize: "0.9rem" }}>
                      <AutoTranslate targetLanguage={language.lang}>{item.location}</AutoTranslate>
                    </span>
                  </div>
                  <div className='flex-evenly-center w-100 py-2'>
                    <div className='flex-column-center-center gap-1'>
                      <OverlayTrigger
                        placement='top'
                        overlay={<Tooltip>{`${item.approvalState === "W" ? wording.waiting : item.approvalState === "Y" ? wording.goToEducation : `${wording.rejectReason} ${item.remark}`}`}</Tooltip>}
                      >
                        <div
                          className={`modern-icon-container ${
                            item.approvalState === "W"
                              ? "modern-icon-warning"
                              : parseInt(item.achievement) !== 100 && item.approvalState === "Y"
                              ? "modern-icon-default"
                              : parseInt(item.achievement) === 100
                              ? "modern-icon-success"
                              : "modern-icon-danger"
                          }`}
                          onClick={() => {
                            if (item.approvalState === "Y") {
                              navigate("/watch-education", { state: { company: location.state.company, site: item } });
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faPersonChalkboard} size='1x' />
                        </div>
                      </OverlayTrigger>
                      {item.approvalState === "W" && (
                        <span className='modern-icon-text'>
                          <AutoTranslate targetLanguage={language.lang}>승인 대기</AutoTranslate>
                        </span>
                      )}
                      {item.approvalState === "Y" && (
                        <span className='modern-icon-text'>
                          <AutoTranslate targetLanguage={language.lang}>교육 듣기</AutoTranslate>
                        </span>
                      )}
                      {item.approvalState === "N" && (
                        <span className='modern-icon-text'>
                          <AutoTranslate targetLanguage={language.lang}>반려</AutoTranslate>
                        </span>
                      )}
                    </div>
                    <div className='modern-divider' />
                    <div className='flex-column-center-center gap-1'>
                      <OverlayTrigger
                        placement='top'
                        overlay={
                          <Tooltip>{`${
                            item.approvalState === "W"
                              ? wording.waiting
                              : item.approvalState === "Y" && item.riskFactorCompletion === "N"
                              ? wording.goToConstruction
                              : item.approvalState === "Y" && item.riskFactorCompletion === "Y"
                              ? wording.completeConstruction
                              : `${wording.rejectReason} ${item.remark}`
                          }`}</Tooltip>
                        }
                      >
                        <div
                          className={`modern-icon-container ${item.approvalState === "W" ? "modern-icon-warning" : item.riskFactorCompletion === "Y" ? "modern-icon-success" : "modern-icon-default"}`}
                          onClick={() => {
                            if (item.approvalState === "Y") {
                              navigate("/construction-test", { state: { company: location.state.company, site: item, isCompleted: item.riskFactorCompletion === "Y" } });
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faHelmetSafety} size='1x' />
                        </div>
                      </OverlayTrigger>
                      <span className='modern-icon-text'>
                        <AutoTranslate targetLanguage={language.lang}>위험성 평가</AutoTranslate>
                      </span>
                    </div>
                    <div className='modern-divider' />
                    <div className='flex-column-center-center gap-1'>
                      <OverlayTrigger placement='top' overlay={<Tooltip>{wording.makeHealthDocument}</Tooltip>}>
                        <div
                          className={`modern-icon-container ${item.pledgeConfirmed ? "modern-icon-success" : "modern-icon-default"}`}
                          onClick={() => {
                            if (item.pledgeConfirmed) {
                              navigate("/health-document", { state: { company: location.state.company, site: item } });
                            } else {
                              navigate("/health-interview", { state: { company: location.state.company, site: item } });
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faFileLines} size='1x' />
                        </div>
                      </OverlayTrigger>
                      <span className='modern-icon-text'>
                        <AutoTranslate targetLanguage={language.lang}>보건 서류 작성</AutoTranslate>
                      </span>
                    </div>
                  </div>
                </Card.Body>
                {item.approvalState === "Y" && parseInt(item.achievement) === 100 && item.riskFactorCompletion === "Y" && item.pledgeConfirmed && (
                  <div className='flex-center-center' style={{ position: "absolute", top: "0px", right: "0px", width: "250px", height: "150px", rotate: "30deg", opacity: "0.5" }}>
                    <img src={CompleteStamp} alt='Complete Stamp' style={{ width: "100%", height: "100%" }} />
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      </div>
      <Dialog
        show={dialog}
        onHide={() => {
          setDialog(false);
          setFormData({
            jobDate: "", // 작업 예정일
            siteId: "",
            siteName: "",
            eduId: "",
            constructionTypeList: [],
            constructionTypes: [],
            unitList: [],
            units: [],
            address: "", // 주소
            emergencyPhone: "", // 비상연락처
            highBloodPressure: "", // 최고 혈압
            lowBloodPressure: "", // 최저 혈압
            workExperience: "-1", // 경력
            smoking: "0", // 흡연 여부
            drinking: "0", // 음주 여부
            pledgeConfirmed: false, // 안전 서약서 동의 여부
          });
          setDialogStep(0);
        }}
        title={formTitles[dialogStep]}
        fullScreen={Commons.IsMobile()}
        backdrop={false}
        className='modern-dialog'
        footerChildren={
          <div className='flex-between-center w-100'>
            <Button variant='outline-secondary' className='modern-btn modern-btn-outline-secondary' onClick={() => setDialogStep(dialogStep - 1)} disabled={dialogStep === 0}>
              <FontAwesomeIcon icon={faChevronLeft} />
              <AutoTranslate targetLanguage={language.lang}>이전</AutoTranslate>
            </Button>
            <Button className='modern-btn modern-btn-outline-primary' onClick={NextStep}>
              {dialogStep === formTitles.length - 1 ? wording.complete : wording.next}
              {dialogStep != formTitles.length - 1 && <FontAwesomeIcon icon={faChevronRight} />}
            </Button>
          </div>
        }
      >
        <div style={{ height: Commons.IsMobile() ? "" : "60vh", overflowY: "auto" }}>
          {dialogLoading && <Loading />}
          {dialogStep === 0 && (
            <div>
              <Form className='w-100 mb-4 px-2' onSubmit={(e) => e.preventDefault()}>
                <Form.Group className='modern-form-group'>
                  <Form.Label className='modern-form-label'>
                    <AutoTranslate targetLanguage={language.lang}>작업 예정일</AutoTranslate>
                  </Form.Label>
                  <Form.Control
                    className='modern-form-control'
                    type='text'
                    placeholder={`${wording.futureDay} ${Commons.DateFormating(new Date(), 2)}`}
                    value={formData.jobDate}
                    onChange={(e) => setFormData({ ...formData, jobDate: Commons.InputDateFormating(e.target.value) })}
                    autoFocus
                  />
                </Form.Group>
              </Form>
              {/* <div className='mb-4 modern-divider' />
              <Form className='w-100 mb-1 px-2' onSubmit={(e) => e.preventDefault()}>
                <Form.Group className='modern-form-group'>
                  <Form.Label className='modern-form-label'>
                    <AutoTranslate targetLanguage={language.lang}>현장 선택</AutoTranslate>
                  </Form.Label>
                </Form.Group>
              </Form>
              <div className='mb-5'>
                <SearchInput isStartIcon isEndXIcon placeholder={wording.placeholder1} text={dialogSearchText} setText={(e) => setDialogSearchText(e)} />
              </div>
              <div className='flex-start-center flex-wrap gap-3 px-2'>
                {checkedSiteList
                  ?.filter((item) => item.siteName.includes(dialogSearchText))
                  .map((item, index) => {
                    return (
                      <Button
                        key={index}
                        className={`${formData.siteId === item.siteId ? "modern-btn-primary" : "modern-btn-outline-primary"} modern-search-result-btn`}
                        size='lg'
                        disabled={item.canApply === "N"}
                        onClick={() => setFormData({ ...formData, siteId: item.siteId, siteName: item.siteName })}
                      >
                        <AutoTranslate targetLanguage={language.lang}>{item.siteName}</AutoTranslate>
                      </Button>
                    );
                  })}
              </div> */}
            </div>
          )}
          {dialogStep === 1 && (
            <div>
              <Form onSubmit={(e) => e.preventDefault()}>
                <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>성명</AutoTranslate>
                    </Form.Label>
                    <Form.Control className='modern-form-control' type='text' value={userInfo.userNm ?? ""} disabled />
                  </Form.Group>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>생년월일</AutoTranslate>
                    </Form.Label>
                    <Form.Control className='modern-form-control' type='text' value={userInfo.birth ?? ""} disabled />
                  </Form.Group>
                </div>
                <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>연락처</AutoTranslate>
                    </Form.Label>
                    <Form.Control className='modern-form-control' type='text' value={userInfo.tel ?? ""} disabled />
                  </Form.Group>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>비상연락처</AutoTranslate>
                    </Form.Label>
                    <Form.Control
                      className='modern-form-control'
                      type='tel'
                      placeholder={wording.placeholder2}
                      value={formData.emergencyPhone}
                      onChange={(e) => setFormData({ ...formData, emergencyPhone: Commons.FormatPhoneNumber(e.target.value, formData.emergencyPhone) })}
                    />
                  </Form.Group>
                </div>
                <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
                  <Form.Group className='w-100 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>주소</AutoTranslate>
                      <span style={{ color: "#dc3545" }}>&#42;</span>
                    </Form.Label>
                    <Form.Control className='modern-form-control' type='text' placeholder={wording.placeholder3} value={formData.address} onClick={() => setDialog1(true)} readOnly />
                  </Form.Group>
                </div>
                <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>최고 혈압 (기준: 150미만)</AutoTranslate>
                      <span style={{ color: "#dc3545" }}>&#42;</span>
                    </Form.Label>
                    <Form.Control
                      className='modern-form-control'
                      type='number'
                      placeholder={wording.placeholder4}
                      value={formData.highBloodPressure}
                      onChange={(e) => setFormData({ ...formData, highBloodPressure: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>최저 혈압 (기준: 90미만)</AutoTranslate>
                      <span style={{ color: "#dc3545" }}>&#42;</span>
                    </Form.Label>
                    <Form.Control
                      className='modern-form-control'
                      type='number'
                      placeholder={wording.placeholder5}
                      value={formData.lowBloodPressure}
                      onChange={(e) => setFormData({ ...formData, lowBloodPressure: e.target.value })}
                    />
                  </Form.Group>
                </div>
                <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
                  <Form.Group className='w-100 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>경력 선택</AutoTranslate>
                      <span style={{ color: "#dc3545" }}>&#42;</span>
                    </Form.Label>
                    <Form.Select className='modern-form-select' value={formData.workExperience} onChange={(e) => setFormData({ ...formData, workExperience: e.target.value })}>
                      <option value='-1'>
                        <AutoTranslate targetLanguage={language.lang}>경력을 선택하세요.</AutoTranslate>
                      </option>
                      <option value='0'>
                        <AutoTranslate targetLanguage={language.lang}>경력 없음</AutoTranslate>
                      </option>
                      <option value='1'>
                        <AutoTranslate targetLanguage={language.lang}>1개월 미만</AutoTranslate>
                      </option>
                      <option value='3'>
                        <AutoTranslate targetLanguage={language.lang}>3개월 미만</AutoTranslate>
                      </option>
                      <option value='6'>
                        <AutoTranslate targetLanguage={language.lang}>6개월 미만</AutoTranslate>
                      </option>
                      <option value='12'>
                        <AutoTranslate targetLanguage={language.lang}>1년 미만</AutoTranslate>
                      </option>
                      <option value='36'>
                        <AutoTranslate targetLanguage={language.lang}>3년 미만</AutoTranslate>
                      </option>
                      <option value='60'>
                        <AutoTranslate targetLanguage={language.lang}>5년 미만</AutoTranslate>
                      </option>
                      <option value='61'>
                        <AutoTranslate targetLanguage={language.lang}>5년 이상</AutoTranslate>
                      </option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>흡연 여부</AutoTranslate>
                      <span style={{ color: "#dc3545" }}>&#42;</span>
                    </Form.Label>
                    <Form.Select className='modern-form-select' value={formData.smoking} onChange={(e) => setFormData({ ...formData, smoking: e.target.value })}>
                      <option value='0'>
                        <AutoTranslate targetLanguage={language.lang}>흡연 여부를 선택하세요.</AutoTranslate>
                      </option>
                      <option value={true}>
                        <AutoTranslate targetLanguage={language.lang}>흡연</AutoTranslate>
                      </option>
                      <option value={false}>
                        <AutoTranslate targetLanguage={language.lang}>비흡연</AutoTranslate>
                      </option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className='w-50 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>음주 여부</AutoTranslate>
                      <span style={{ color: "#dc3545" }}>&#42;</span>
                    </Form.Label>
                    <Form.Select className='modern-form-select' value={formData.drinking} onChange={(e) => setFormData({ ...formData, drinking: e.target.value })}>
                      <option value='0'>
                        <AutoTranslate targetLanguage={language.lang}>음주 여부를 선택하세요.</AutoTranslate>
                      </option>
                      <option value={true}>
                        <AutoTranslate targetLanguage={language.lang}>음주</AutoTranslate>
                      </option>
                      <option value={false}>
                        <AutoTranslate targetLanguage={language.lang}>비음주</AutoTranslate>
                      </option>
                    </Form.Select>
                  </Form.Group>
                </div>
              </Form>
            </div>
          )}
        </div>
      </Dialog>
      <KakaoAddress show={dialog1} onHide={() => setDialog1(false)} onReceivePost={HandleReceivePost} />
    </div>
  );
}

export default Composed;
